import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=12a91afc&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a91afc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12a91afc')) {
      api.createRecord('12a91afc', component.options)
    } else {
      api.reload('12a91afc', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=12a91afc&scoped=true&", function () {
      api.rerender('12a91afc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2qQkPUOA432q7/JS/comp/Accordion.vue"
export default component.exports